// extracted by mini-css-extract-plugin
export default {"betaLabel":"SkillModelSelector_betaLabel__WXMlu"};